// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"308":"lazy-stake-cart","500":"modal-connect-wallet","547":"modal-features"}[chunkId] || chunkId) + "." + {"57":"65d682f0","126":"7e82730c","143":"8702fb19","204":"c4a47ed2","308":"a2d166eb","431":"fa23da29","500":"f0528884","507":"057d744c","547":"b531e92c","787":"5db7eefb"}[chunkId] + ".chunk.js";
};